import { Component } from '@angular/core';
import {UserService} from "./_services";
import {Router} from "@angular/router";

@Component({
  selector: 'app-root',
  template: '<router-outlet><app-spinner></app-spinner></router-outlet>'
})
export class AppComponent {
  title = 'Guru Able 4+';

  constructor(
    private router: Router,
    private userService: UserService
  ){
    if (!this.userService.getToken()){
      this.router.navigate(['/login']);
    }
  }
}



// WEBPACK FOOTER //
// /Users/pakornduangtrakan/Snocko/other/backend-auto/src/app/app.component.ts